import { render } from "./BaseIcon.vue?vue&type=template&id=1f1293d8&scoped=true&ts=true"
import script from "./BaseIcon.vue?vue&type=script&lang=ts"
export * from "./BaseIcon.vue?vue&type=script&lang=ts"

import "./BaseIcon.vue?vue&type=style&index=0&id=1f1293d8&lang=scss&scoped=true"
import "./BaseIcon.vue?vue&type=style&index=1&id=1f1293d8&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1293d8"]])

export default __exports__